export enum UserIdentifierEnum {
    CPF = 'cpf',
    CNPJ = 'cnpj',
    External = 'externalDoc'
}
